import { useSWR } from '@tiger/swr';
import { FC } from 'react';
import Skeleton from 'components/base/Skeleton';
import ErrorBox from 'components/ErrorBox';
import WeakNetPrompt from 'components/forms/WeakNetPrompt';
import FormSelect, { FormSelectProps } from 'components/FormSelect';
import API from 'utils/API';

export interface UsStatesSelectProps extends Omit<FormSelectProps, 'options'> {
    // homeAddress和deliveryAddress同时存在时使用此参数进行区分
    prefix?: string;
}

export interface UsStateItem {
    name: string;
    abbr: string;
}

const UsStatesSelect: FC<UsStatesSelectProps> = ({
    disabled,
    placeholder = __('Please Select'),
    prefix = '',
    ...restProps
}) => {
    const {
        data: dataStates,
        isLoading,
        error,
        mutate
    } = useSWR<UsStateItem[]>(API.CUSTOMER.fields.stateUS(), {
        dataChain: res => res.data,
        immutable: true
    });

    if (error && !dataStates) {
        return (
            <div className="mb-3">
                <ErrorBox error={error} onClick={() => mutate()} />
                <WeakNetPrompt name={`temporary_us_states_${prefix}`} type="error" />
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="mb-3">
                <Skeleton line={2} />
                <WeakNetPrompt name={`temporary_us_states_${prefix}`} type="loading" />
            </div>
        );
    }

    return (
        <FormSelect
            disabled={disabled}
            placeholder={placeholder}
            options={
                dataStates?.map(item => ({
                    value: item.abbr,
                    label: item.name
                })) || []
            }
            {...restProps}
        />
    );
};

export default UsStatesSelect;
